import {LitElement, html, TemplateResult, PropertyValues} from 'lit';
/**
 * `billing-section`
 */
export class BillingSection extends LitElement {
  /**
   * Render in the light dom
   *
   * @returns {object} this
   */
  createRenderRoot() {
    return this;
  }

  /**
   * Defined the elements content
   *
   * @returns {TemplateResult} the resulting html template
   */
  render() {
    if (this.isError) {
      return html`<p>Oops there has been an error</p>`;
    }

    if (this.isCreatingCheckout) {
      return html`<p>Loading checkout...</p>`;
    }

    if (this.isLoading) {
      return html`<p>Loading billing status...</p>`;
    }

    if (this.status === 'paid') {
      return html`
                <p>Thank you for subscribing!</p>
                <a href="${this.portal}" target="_blank">Manage your subscription</a>
            `;
    }

    if (this.status === 'payment_failed') {
      return html`
                <p>There is an issue with your subscription.</p>
                <a href="${this.portal}" target="_blank">Please update your subscription</a>
            `;
    }

    return html`
            <p>Please subscribe to begin syncing your data.</p>
            <a @click=${this._upgrade}>Subscribe</a>
        `;
  }

  /**
   * Defines the elements properties
   *
   * @returns {object} the elements properties
   */
  static get properties() {
    return {
      /** Used to interact with api */
      service: {type: Object},
      /** If we are loading data */
      isLoading: {type: Boolean},
      /** If there is an error loading data*/
      isError: {type: Boolean},
      /** If we are creating checkout */
      isCreatingCheckout: {type: Boolean},
      /** Billing status */
      status: {type: String},
      /** Billing portal */
      portal: {type: String},
    };
  }

  /** Initialises values of properties */
  constructor() {
    super();
    this.service = {};
    this.isLoading = false;
    this.isError = false;
    this.isCreatingCheckout = false;
  }

  /**
   * Fired whenever any property changes and the template updates
   *
   * @param {PropertyValues} changedProperties map of changed properties
   */
  updated(changedProperties) {
    if (super.updated) {
      super.updated(changedProperties);
    }

    if (changedProperties.has('service') &&
            this.service?.getConfig
    ) {
      this._load();
    }
  }

  /**
   * Load the billing information
   */
  async _load() {
    try {
      this.isCreatingCheckout = false;
      this.isError = false;
      this.isLoading = true;
      const {status, portal} = await this.service.getBilling();
      this.status = status;
      this.portal = portal;
    } catch (e) {
      console.error(e);
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * Upgrade the user to paid plan
   */
  async _upgrade() {
    try {
      this.isError = false;
      this.isLoading = false;
      this.isCreatingCheckout = true;
      const response = await this.service.createBillingCheckout();
      const stripe = new window.Stripe('pk_live_51H5bxZBUyPlmYVFekvKoLbMtT2dhyIxeU0KETEabV79pLPMXgqR1XmB0uZBZxKFgoFXhYauzuoEjtyEZv9ZL1U8q00HVKv6Grd');
      await stripe.redirectToCheckout({
        sessionId: response.sessionID,
      });
    } catch (e) {
      console.error(e);
      this.isError = true;
    } finally {
      this.isCreatingCheckout = false;
    }
  }
}
window.customElements.define('billing-section', BillingSection);
